/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core';
import React from 'react';
import { Button } from 'react-bootstrap';
import SVGComponent from '../../../../../../SharedModules/SVGComponents/SVGComponents';
import { NDCDetailsTextFieldComponent } from '../../../../../Display/NDC/component/NDCDetails/NDCDetailsHeaderDetailsComponent';
import cancelIcon from '../../../../../../assets/images/Icon-cancel.png';
import { PaperComponent } from '../../../../../../SharedModules/utilities/utilities';

const DeleteBatchPopup = ({
  open = false,
  onConfirmClick = () => {},
  handleClose = () => {},
  data = {},
}) => {
  return (
    <Dialog
      open={open}
      className="inbuilt-dialog dialogPanel custom-check dialog-900"
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
    >
        <DialogTitle className="copy-contact-title" style={{ cursor: 'move' }} id="draggable-dialog-title">
          <div className="float-left dialog-heading-txt mt-1">
            Request Delete Batch Totals
          </div>
          <div
            className="close-popup-icon float-right"
            role="button"
            onClick={handleClose}
          >
            <img alt="" src={cancelIcon} />
          </div>
        </DialogTitle>
        <DialogContent>
          <div className="custom-panel">
            <div className="row mt-3" style={{ margin: '0' }}>
              <div className="col-12 mb-2">
                <NDCDetailsTextFieldComponent
                  label="Batch Number"
                  value={data && data.batchNum}
                  className="ml-0 mb-0"
                  onChange={() => {}}
                />
              </div>
              <div className="col-6 mb-2">
                <NDCDetailsTextFieldComponent
                  label="Batch Date"
                  value={data && data.batchDt}
                  className="ml-0 mb-0"
                  onChange={() => {}}
                />
              </div>
              <div className="col-6 mb-2">
                <NDCDetailsTextFieldComponent
                  label="Check Payee Cd"
                  value={data && data.checkPayeeCd}
                  className="ml-0 mb-0"
                  onChange={() => {}}
                />
              </div>
              <div className="col-6 mb-2">
                <NDCDetailsTextFieldComponent
                  label="Total Check Cnt"
                  value={data && data.totCheckCnt}
                  className="ml-0 mb-0"
                  onChange={() => {}}
                />
              </div>
              <div className="col-6 mb-2">
                <NDCDetailsTextFieldComponent
                  label="Total Check Amt"
                  value={data && data.totCheckAmt}
                  className="ml-0 mb-0"
                  onChange={() => {}}
                />
              </div>
            </div>
          </div>
        </DialogContent>

        <DialogActions>
          <div className="btn-wrapper mb-2">
            <div className="float-right hide-on-print">
              <Button
                className="btn btn-success btn-search"
                data-testid="reset-contact-detail"
                onClick={onConfirmClick}
              >
                <SVGComponent iconName="Icon_awesome-check-circle" />
                Ok
              </Button>
              <Button
                data-testid="copy-contact-close"
                className="btn btn-cancel btn-primary"
                onClick={handleClose}
              >
                <SVGComponent iconName="Icon-cancel" />
                Cancel
              </Button>
            </div>
            <div className="clearfix" />
          </div>
        </DialogActions>
    </Dialog>
  );
};

export default DeleteBatchPopup;
